<div class="d-flex justify-content-center align-items-center h-100 flex-column">
  <h2 class="display-4">{{'COMMON.LABEL.PAGE_NOT_FOUND' | translate}}</h2>
  <button mat-flat-button
    routerLink="/">{{'COMMON.LABEL.BACK_TO_HOME' | translate}}</button>
</div>